import {Injectable} from '@angular/core';
import {SidenavFilter, SidenavFilterChain, SidenavItem} from '@mctic/ng-core';
import {Observable, of} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {ResponsavelRdaService, SecurityService} from 'src/app/service';
import {SigplaniModuloEnum} from '../../shared/enum/sigplani-modulo.enum';
import {SidenavItemEnum} from '../sidenav-item.enum';

@Injectable({
  providedIn: 'root'
})
export class IndicadoResponsavelRdaSidenavFilter implements SidenavFilter {

  readonly mappings: string[] = [];

  readonly skipping: string[] = [
    SidenavItemEnum.PaginaInicial,
    SidenavItemEnum.SelecionaEntidade,
    SidenavItemEnum.IdentificacaoEmpresa
  ];

  constructor(private readonly responsavelRda: ResponsavelRdaService,
    private readonly securityService: SecurityService) {
  }

  canActivate(sidenavItem: SidenavItem): Observable<boolean> {
    return of(this.securityService.isModuloAtivo(SigplaniModuloEnum.RDA) &&
      this.securityService.isEmpresaAutenticada());
  }

  doFilter(sidenavItem: SidenavItem, chain: SidenavFilterChain): Observable<boolean> {
    return this.responsavelRda.isResponsavelIndicado().pipe(
      switchMap(responsavelIndicado => chain.nextOrComplete(sidenavItem, responsavelIndicado))
    );
  }


}
